import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import "./PersonalTransferContext.css";

function PersonalTransferContext({ user }) {
  const [isSaving, setIsSaving] = useState(false);
  const [chatContext, setChatContext] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);  // New state for expand/collapse

  const placeholderText = ``;
  const typingTimer = useRef(null);
  const nameInputRef = useRef(null);

  const handleSave = async () => {
    setIsSaving(true);

    const inputText = nameInputRef.current.value;
    const jwt_token = localStorage.getItem('jwt_authorization');

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/system-prompt/personal_transfer_context`, {
        input_text: inputText,
        jwt_token,
      });
    } catch (error) {
      console.error('Failed to update:', error);
    }

    setIsSaving(false);
  };

  const handleInputChange = (e) => {
    if (typingTimer.current) {
      clearTimeout(typingTimer.current);
    }
    typingTimer.current = setTimeout(handleSave, 2000);
  };

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_BACKEND_HOST}/system-prompt/personal_transfer_context`, {
      jwt_token: localStorage.getItem('jwt_authorization'),
    })
      .then(response => {
        setChatContext(response.data);
      })
      .catch(error => {
        console.error('Error fetching personal_transfer_context', error);
      });
  }, [user]);

  const handleToggleClick = () => {
    setIsExpanded(!isExpanded);  // Toggle the state
  };

  return (
    <div className='chat-context-container'>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "baseline", justifyContent: "space-between" }} >
        <span className='general-info-label'>Personal Call Transer Context</span>
        <div onClick={handleToggleClick} style={{ cursor: "pointer"}}>toggle</div>
      </div>
      {isExpanded && (  // Conditionally render the textarea
        <textarea
          ref={nameInputRef}
          className="chat-context"
          placeholder={placeholderText}
          defaultValue={chatContext}
          onChange={handleInputChange}
        />
      )}
      <div className='chat-context-status-wrapper'>
        {isSaving && <img className="saving-animation" src="/images/saving.gif" alt="Saving..." />}
      </div>
    </div>
  );
}

export default PersonalTransferContext;
